import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, Spinner } from 'react-bootstrap';

const LoadingButton = ({
  text,
  action,
  isLoading,
  disabled,
  icon,
  ...rest
}) => (
  <Button
    className="me-2 mb-1 d-inline-flex flex-center"
    onClick={action}
    disabled={isLoading || disabled}
    {...rest}
  >
    {isLoading && (
      <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
        className="me-2"
      />
    )}
    {text}
    {icon && <FontAwesomeIcon className="ms-2" icon={icon} />}
  </Button>
);

// proptypes validation
LoadingButton.propTypes = {
  text: PropTypes.string.isRequired,
  action: PropTypes.func,
  isLoading: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  icon: PropTypes.any
};

export default LoadingButton;
